import * as React from "react";
const FileIcon = (
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={18}
    fill="none"
    {...props}
  >
    <path
      stroke="#202A2D"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M3.47 7.354v-4.53a1.235 1.235 0 1 1 2.471 0v4.53a2.47 2.47 0 1 1-4.941 0V4.06M8.824.766h2.223c1.384 0 2.075 0 2.604.269a2.47 2.47 0 0 1 1.08 1.08C15 2.643 15 3.335 15 4.719v8.564c0 1.384 0 2.076-.27 2.604a2.47 2.47 0 0 1-1.079 1.08c-.528.27-1.22.27-2.604.27h-5.27c-1.384 0-2.076 0-2.605-.27a2.47 2.47 0 0 1-1.08-1.08c-.268-.528-.268-1.22-.268-2.604v-.576"
    />
  </svg>
);
export default FileIcon;
